










import { Component, Vue } from "vue-property-decorator";
import { getMessages } from "../api";
import { Message } from "../models/message";
import MessageReadBlock from "../components/MessageReadBlock.vue";
import moment from "moment";

@Component({
  components: { MessageReadBlock }
})
export default class MessagesOverview extends Vue {
  private messages: Message[] = [];

  private async mounted() {
    this.messages = (await getMessages()).sort(
      (a: Message, b: Message): number => {
        const ma = moment(a.created_at);
        const mb = moment(b.created_at);
        if (ma.isBefore(mb)) return 1;
        if (ma.isSame(mb)) return 0;
        return -1;
      }
    );
  }
}
